export const SET_AUTHORIZED = 'SET_AUTHORIZED';
export const SET_UNAUTHORIZED = 'SET_UNAUTHORIZED';
export const UPDATE_USERNAME = 'UPDATE_USERNAME';
export const UPDATE_SESSION_EXPIRY_TIME = 'UPDATE_SESSION_EXPIRY_TIME';
export const UPDATE_KEYCLOAK_REALM = 'UPDATE_KEYCLOAK_REALM';
